import { Injectable } from '@angular/core';
import { RandomId } from '../ly/random-id';
var Log = (function () {
    /**
     * @param {?} randomId
     */
    function Log(randomId) {
        this.randomId = randomId;
        this._logs = [];
    }
    /**
     * @param {?} _name
     * @param {?=} val
     * @return {?}
     */
    Log.prototype.setLog = function (_name, val) {
        if (val === void 0) { val = undefined; }
        var /** @type {?} */ key = this.randomId.generate;
        this._logs.push({
            key$: key,
            name: _name,
            log: val,
        });
        console.warn("LOG_>", {
            key$: key,
            name: _name,
            log: val,
        });
    };
    Object.defineProperty(Log.prototype, "logs", {
        /**
         * @return {?}
         */
        get: function () {
            return this._logs;
        },
        enumerable: true,
        configurable: true
    });
    return Log;
}());
export { Log };
Log.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Log.ctorParameters = function () { return [
    { type: RandomId, },
]; };
function Log_tsickle_Closure_declarations() {
    /** @type {?} */
    Log.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    Log.ctorParameters;
    /** @type {?} */
    Log.prototype._logs;
    /** @type {?} */
    Log.prototype.randomId;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/core/log/log.js
// module id = 1374
// module chunks = 31